import React, {useState} from 'react';
import {Alert, Button, Form, Input, Modal, Select, Space} from 'antd';
import {CloseOutlined, PlusOutlined, SaveOutlined} from '@ant-design/icons';
import {createProjectMenu} from '../../api/projectMenuApi';

function ProjectMenuCreateModal({ isOpen, onClose, onSuccess, pjtId }) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (values) => {
    if (!pjtId) {
      setError('프로젝트 정보가 없습니다.');
      return;
    }
    setError('');
    setLoading(true);
    try {
      await createProjectMenu(pjtId, values);
      form.resetFields();
      onSuccess && onSuccess();
      onClose();
    } catch (err) {
      setError('등록에 실패했습니다: ' + (err?.response?.data?.message || err.message));
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    form.resetFields();
    setError('');
    onClose();
  };

  return (
    <Modal
      title={
        <Space>
          <PlusOutlined />
          <span>프로젝트 메뉴 신규생성</span>
        </Space>
      }
      open={isOpen}
      onCancel={handleClose}
      width={800}
      footer={null}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        initialValues={{ menuNm: '', sortSeq: '', url: '', parentMenuId: '', useYn: 'Y', menuExpln: '' }}
      >
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
          <Form.Item label="메뉴명" name="menuNm" rules={[{ required: true, message: '메뉴명을 입력해주세요' }]}>
            <Input placeholder="예: 기본 메뉴" />
          </Form.Item>
          <Form.Item label="정렬순서" name="sortSeq">
            <Input placeholder="예: 10" />
          </Form.Item>
          <Form.Item label="URL" name="url">
            <Input placeholder="예: /projects" />
          </Form.Item>
          <Form.Item label="부모메뉴ID" name="parentMenuId">
            <Input placeholder="상위 메뉴가 있다면 입력" />
          </Form.Item>
          <Form.Item label="사용여부" name="useYn">
            <Select
              options={[
                { value: 'Y', label: 'Y' },
                { value: 'N', label: 'N' },
              ]}
            />
          </Form.Item>
          <Form.Item label="메뉴설명" name="menuExpln" style={{ gridColumn: '1 / span 2' }}>
            <Input.TextArea rows={3} placeholder="메뉴 설명을 입력하세요" />
          </Form.Item>
        </div>

        {error && (
          <Alert message="오류" description={error} type="error" showIcon style={{ marginBottom: 16 }} />
        )}

        <div style={{ textAlign: 'right' }}>
          <Button icon={<CloseOutlined />} onClick={handleClose} style={{ marginRight: 8 }}>
            취소
          </Button>
          <Button type="primary" htmlType="submit" icon={<SaveOutlined />} loading={loading}>
            저장
          </Button>
        </div>
      </Form>
    </Modal>
  );
}

export default ProjectMenuCreateModal;

